import { ComponentProps } from 'react'

import LazyImage from '../LazyImage'

import type { ResponsiveImageProperties } from './types'

type LazyImageProps = ComponentProps<typeof LazyImage>

type ResponsiveImageProps = ResponsiveImageProperties & LazyImageProps

const ResponsiveImage = (props: ResponsiveImageProps) => {
  let src
  let srcset
  let lazyImageProps: LazyImageProps = {}

  if ('w800' in props) {
    const { w400, w800, w1200, ...rest } = props
    lazyImageProps = rest
    src = w800
    srcset = `
      ${w800} 800w,
      ${w1200 ? `${w1200} 1200w` : ''},
      ${w400 ? `${w400} 400w` : ''},
    `
  } else if ('medium' in props) {
    const { medium, large, ...rest } = props
    lazyImageProps = rest
    src = medium
    srcset = `
      ${medium} 600w,
      ${large ? `${large} 1200w` : ''},
    `
  }

  return <LazyImage {...lazyImageProps} data-src={src} data-srcset={srcset} />
}

export default ResponsiveImage
